import { apiRequest } from "../api.js";

// 判断是否有缴费
export function isPay(config){
  config.method = "get";
  config.url = "/app-api/person/pay/get-pay-status";
  apiRequest(config);
}

//新版基本信息填写
export function registerInfo(config) {
  config.method = "post";
  config.url = "/app-api/person/register/register-info";
  apiRequest(config);
}
//新版证书填写
export function registerCert(config) {
  config.method = "post";
  config.url = "/app-api/person/register/register-cert";
  apiRequest(config);
}
// 缴费信息填写
export function registerPay(config) {
  config.method = "post";
  config.url = "/app-api/person/register/register-pay";
  apiRequest(config);
}

// 获取非会员消息中心的列表数据
export function getNoVipList(config) {
  config.method = "post";
  config.url = "/meetingapi/v1/notice/get-list";
  apiRequest(config);
}

// 非会员单个标记已读
export function getNoVipRead(config) {
  config.method = "post";
  config.url = "/meetingapi/v1/notice/read";
  apiRequest(config);
}
// 非会员单个标记删除
export function getNoVipDelete(config) {
  config.method = "post";
  config.url = "/meetingapi/v1/notice/notice-delete";
  apiRequest(config);
}
// 非会员多个标记已读
export function getNoVipAllRead(config) {
  config.method = "post";
  config.url = "/meetingapi/v1/notice/all-read";
  apiRequest(config);
}
// 非会员多个删除
export function getNoVipAllDelete(config) {
  config.method = "post";
  config.url = "/meetingapi/v1/notice/all-notice-delete";
  apiRequest(config);
}

// 获取消息中心的列表数据
export function getList(config) {
  config.method = "get";
  config.url = "/app-api/person/notice/get-list";
  apiRequest(config);
}

// 消息或多个标记已读
export function haveReadOne(config) {
  config.method = "post";
  config.url = "/app-api/person/notice/read";
  apiRequest(config);
}
export function haveReadAll(config) {
  config.method = "post";
  config.url = "/app-api/person/notice/all-read";
  apiRequest(config);
}

// 单个或多个删除
export function haveDeleteOne(config) {
  config.method = "post";
  config.url = "/app-api/person/notice/notice-delete";
  apiRequest(config);
}
export function haveDeleteAll(config) {
  config.method = "post";
  config.url = "/app-api/person/notice/all-notice-delete";
  apiRequest(config);
}

// 完善手机号
export function updatePhone(config) {
  config.method = "post";
  config.url = "/personapi/v1/person/update-cellphone";
  apiRequest(config);
}

// 变更证书
export function updateCert(config) {
  config.method = "post";
  config.url = "/app-api/person/member-person-app/update-cert";
  apiRequest(config);
}

// 获取证书列表
export function getCertList(config) {
  config.method = "get";
  config.url = "/app-api/person/member-person-app/get-list";
  apiRequest(config);
}
// 新增证书
export function addCert(config) {
  config.method = "post";
  config.url = "/app-api/person/member-person-app/add-cert";
  apiRequest(config);
}

// 获取个人信息待审核状态
export function getInfoStatus(config) {
  config.method = "post";
  config.url = "/app-api/person/member-person-app/get-info-status";
  apiRequest(config);
}

// 修改密码
export function changePassword(config) {
  config.method = "post";
  config.url = "/app-api/person/password/update-password";
  apiRequest(config);
}

// 获取证书是否有待审核状态
export function isCertStatus(config) {
  config.method = "post";
  config.url = "/app-api/person/member-person-app/get-cert-status";
  apiRequest(config);
}

// 信息变更详情
export function infoChangeDetail(config) {
  config.method = "post";
  config.url = "/app-api/person/apply/get-detail";
  apiRequest(config);
}
// 上传缴费凭证
export function uploadPayRecom(config) {
  config.method = "post";
  config.url = "/app-api/person/pay/upload-paper";
  apiRequest(config);
}

// 获取变更申请
export function getChangeRecord(config) {
  config.method = "get";
  config.url = "/app-api/person/apply/page";
  apiRequest(config);
}
// 获取缴费管理
export function getPayRecord(config) {
  config.method = "post";
  config.url = "/app-api/person/pay/page";
  apiRequest(config);
}

// 会员信息变更
export function saveInfo(config) {
  config.method = "post";
  config.url = "/app-api/person/member-person-app/save-info";
  apiRequest(config);
}
// 获取个人会员信息
export function getVipUser(config) {
  config.method = "get";
  config.url = "/app-api/person/get-member-info";
  apiRequest(config);
}
// 获取专家评分iframe
export function getExpertIfame(config) {
  config.method = "get";
  config.url = "/app-api/person/config/get-menu-url";
  apiRequest(config);
}
// 登录
export function loginUser(config) {
  config.method = "post";
  config.url = "/app-api/person/login";
  apiRequest(config);
}

// 注册个人会员
export function registerUser(config) {
  config.method = "post";
  config.url = "/app-api/person/register/register-login";
  apiRequest(config);
}
// 注册发送短信
export function sendMessage(config) {
  config.method = "post";
  config.url = "/app-api/person/register/send-sms";
  apiRequest(config);
}
// 获取注册协议
export function registerPaper(config) {
  config.method = "get";
  config.url = "/app-api/person/login/get-register-paper";
  apiRequest(config);
}

// 获取入会须知 /person/login/get-join-paper
export function getJoinPaper(config) {
  config.method = "get";
  config.url = "/app-api/person/login/get-join-paper";
  apiRequest(config);
}

// 忘记密码
export function findPassword(config) {
  config.method = "post";
  config.url = "/app-api/person/login/find-password";
  apiRequest(config);
}

// 获取基本信息
export function getBasicInfo(config) {
  config.method = "get";
  config.url = "/app-api/website/news/get-web-base-info";
  apiRequest(config);
}

// 获取友情链接
export function apirequest(config) {
  config.method = "post";
  config.url = "/adminapi/web/get-web-link";
  apiRequest(config);
}

// 获取网站导航栏
export function getNavList(config) {
  config.method = "get";
  config.url = "/app-api/website/news/get-web-nav";
  apiRequest(config);
}

// 登录前会员公告
export function getNotice(config) {
  config.method = "post";
  config.url = "/appapi/login/get-notice";
  apiRequest(config);
}
//登录前会员服务
export function getService(config) {
  config.method = "post";
  config.url = "/appapi/login/get-service";
  apiRequest(config);
}

// 登录
export function userLogin(config) {
  config.method = "post";
  config.url = "/appapi/login/login";
  apiRequest(config);
}

// 记录会员公告/服务阅读统计
export function userReadRecord(config) {
  config.method = "post";
  config.url = "/appapi/login/update-read";
  apiRequest(config);
}

// 注册
export function userRegister(config) {
  config.method = "post";
  config.url = "/personapi/login/register";
  apiRequest(config);
}

//搜索
export function userSearch(config) {
  config.method = "post";
  config.url = "/appapi/login/select-member";
  apiRequest(config);
}

// 忘记密码
export function forgetPassword(config) {
  config.method = "post";
  config.url = "/appapi/login/password";
  apiRequest(config);
}

//发码平台发送验证码
export function sendSms(config) {
  config.method = "post";
  config.url = "/appapi/login/send-sms";
  apiRequest(config);
}

// 获取省份地市
export function getLocation(config) {
  config.method = "post";
  config.url = "/appapi/login/get-province";
  apiRequest(config);
}

// 获取城市
export function getCity(config) {
  config.method = "post";
  config.url = "/appapi/login/get-city";
  apiRequest(config);
}

// 获取区域
export function getArea(config) {
  config.method = "post";
  config.url = "/appapi/login/get-area";
  apiRequest(config);
}

// 获取阿里oss地址
export function getAliOssAddress(config) {
  config.method = "post";
  config.url = "/appapi/login/get-oss-path";
  apiRequest(config);
}

// 获取注册协议和服务热线
export function getRegister(config) {
  config.method = "post";
  config.url = "/appapi/login/get-member-config";
  apiRequest(config);
}

// 获取申请注册申请表
export function getApplyinfo(config) {
  config.method = "post";
  config.url = "/adminapi/login/view-sign";
  apiRequest(config);
}

/* 获取企业前缀*/
export function getCompony(config) {
  config.method = "post";
  config.url = "/appapi/login/get-company";
  apiRequest(config);
}

//获取会员单位列表
export function getVipComponay(config) {
  config.method = "post";
  config.url = "/appapi/login/member-list";
  apiRequest(config);
}

// 获取北建联图标logo
export function getIcon(config) {
  config.method = "post";
  config.url = "/adminapi/web/get-web-base-info";
  apiRequest(config);
}

// 保存视频进度
export function saveVideoSpeed(config) {
  config.method = "post";
  config.url = "/app-api/website/news/save-video-speed";
  apiRequest(config);
}
// 获取视频进度
export function getVideoSpeed(config) {
  config.method = "get";
  config.url = "/app-api/website/news/get-video-speed";
  apiRequest(config);
}

// 获取个人会员留言列表 - /app-api/person/leave-message/list
export function getLeaveMessageList(config) {
  config.method = "post";
  config.url = "/app-api/person/leave-message/list";
  apiRequest(config);
}

// 创建个人会员留言 - /app-api/person/leave-message/create
export function createLeaveMessage(config) {
  config.method = "post";
  config.url = "/app-api/person/leave-message/create";
  apiRequest(config);
}
// 获取个人会员留言详情 - /app-api/person/leave-message/detail
export function getLeaveMessageDetail(config) {
  config.method = "get";
  config.url = "/app-api/person/leave-message/detail";
  apiRequest(config);
}

// 修改图标
export const changeFavicon = (link) => {
  let favicon = document.querySelector('link[rel="icon"]');
  if (favicon !== null) {
    favicon.href = link;
  } else {
    favicon = document.createElement("link");
    favicon.rel = "icon";
    favicon.href = link;
    document.head.appendChild(favicon);
  }
};


// 切换视频点赞状态
export function toggleVideoLike(config) {
  config.method = "post";
  config.url = "/app-api/website/news/toggle-video-like?videoId=" + config.data.videoId;
  apiRequest(config);
}